import * as React from 'react'
import { SVGProps } from 'react'

const KASUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
    <path
      d='M32.6556 39.5744L26.7432 38.6952L28.4356 27.266L16.0613 36.7903L12.4274 32.0355L23.2778 23.6761L12.4274 15.324L16.0613 10.5692L28.4356 20.0935L26.7432 8.66432L32.6556 7.78516L35 23.6761L32.6556 39.5744Z'
      fill='#6FC7BA'
    />
  </svg>
)

export default KASUSD
